import React from 'react';
import style from './IconButton.module.css';
import icons from '../../../icons';


const IconButton = props => {
    return <main className={ style.main } style={{ background: props.background && props.background, width: props.width, height: props.height && props.height, ...props.style }} onClick={ e => {
        if (!props.disabled && !props.loading)
            props.onClick?.(e);
    } }>
        { props.loading ? <div className={ style.spinner }></div> : <>
            <img src={ props.icon ?? icons.question_mark_orange_icon } style={{ width: props.iconDimensions && props.iconDimensions, height: props.iconDimensions && props.iconDimensions, ...props.iconStyle }} className={ style.icon }></img>
            <h4 style={{ fontSize: props.fontSize && props.fontSize, ...props.textStyle }} className={ style.text }>{ props.text }</h4>
        </> }
    </main>
};

export default IconButton;

// Purple: linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))
// Orange: linear-gradient(to left, rgb(150, 85, 1), rgb(255, 115, 0))
// Green: linear-gradient(to left, rgb(10, 107, 2), rgb(5, 209, 56))
// Red: linear-gradient(to left, rgb(150, 1, 1), rgb(255, 8, 0)